import AgentsOverview from "pages/Admin/Agents/AgentsOverview";

export default function AgentsOverviewPage() {
  return <AgentsOverview />;
}
